<div class="contents-area">
  <div class="block-row">
    <div class="column-list">
      <label class="list-input-title">媒体</label>
      <div class="list-input-content">
        <app-versatile-combo-box [listSource]="kymw4800Model.mediumList" valueField="mediumType" labelField="mediumName"
          [(ngModel)]="kymw4800Model.mediumType" [required]="true" [width]="280" [tabindex]="0" [visible]="true" [autofocus]="false" [dspBothField]="true"
          (ngModelChange)="eventMediumType_CHANGEHandler()" forcedEnabledMode="true" id="cmb_MediumType" [subid]="'cmb_MediumType'" #cmb_MediumType>
        </app-versatile-combo-box>
      </div>
    </div>
  </div>

  <div>
    <h1>クロス商品一覧</h1>
    <wj-flex-grid #dtg_CrossGoodsList [style.width.px]="1623" [style.height.px]="750"
      [itemsSource]="kymw4800Model.crossGoodsList" [allowMerging]="'ColumnHeaders'" [allowDragging]="'None'"
      horizontalScrollPolicy="'off'" [headersVisibility]="'Column'" [selectionMode]="'Row'"
      verticalScrollPolicy="'on'" [allowSorting]="false" [autoRowHeights]="true" forcedEnabledMode="true"
      [tabindex]="0">
      <wj-flex-grid-column [header]="'直近企画回'" [width]="100" [binding]="'DelivCatalogId'" [align]="'left'"
        [isReadOnly]="true" [minWidth]="5">
      </wj-flex-grid-column>
      <wj-flex-grid-column [header]="'自動初期設定'" [width]="112" [binding]="'AutoDefaultSettings'" [isReadOnly]="true"
        [align]="'center'" [multiLine]="true" [minWidth]="5">
        <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
          <input type="checkbox" id="AutoDefaultSettings_{{cell.row.index}}" [(ngModel)]="cell.item.AutoDefaultSettings"
            (click)="eventEdit_CHANGEHandler()" [tabindex]="-1" />
        </ng-template>
      </wj-flex-grid-column>

      <ng-template ngFor let-data [ngForOf]="kymw4800Model.displayList" let-i="index">
        <wj-flex-grid-column [header]="'Pコード'" [width]="colWidths['pcode']" [isReadOnly]="true" [minWidth]="5">
          <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
            <div class="first-cell">{{kymw4800Model.crossGoodsMap[cell.item.CrossCode][i].PCode}}</div>
          </ng-template>
        </wj-flex-grid-column>
        <wj-flex-grid-column [header]="'商品名'" [width]="colWidths['guideGoodsName']" [isReadOnly]="true" [minWidth]="5">
          <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
            <div>{{kymw4800Model.crossGoodsMap[cell.item.CrossCode][i].GuideGoodsName}}</div>
          </ng-template>
        </wj-flex-grid-column>
        <wj-flex-grid-column [header]="'規格名'" [width]="colWidths['guideStandardName']" [isReadOnly]="true" [minWidth]="5">
          <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
            <div>{{kymw4800Model.crossGoodsMap[cell.item.CrossCode][i].GuideStandardName}}</div>
          </ng-template>
        </wj-flex-grid-column>
        <wj-flex-grid-column [header]="'子コマ配置'" [width]="colWidths['childKoma']" [isReadOnly]="true" [align]="'center'" [minWidth]="5">
          <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
            <!-- 掲載順 1 のみ非表示、掲載順 2 以降は表示 -->
            <div *ngIf="i > 0">
              <input type="checkbox" [(ngModel)]="kymw4800Model.crossGoodsMap[cell.item.CrossCode][i].ChildKomaSettings"
                [tabindex]="-1" *ngIf="kymw4800Model.crossGoodsMap[cell.item.CrossCode][i].ChildKomaSettings !== '-'"
                (click)="eventEdit_CHANGEHandler()" id="ChildKomaSettings_{{cell.col.index}}_{{cell.row.index}}"/>
              <div *ngIf="kymw4800Model.crossGoodsMap[cell.item.CrossCode][i].ChildKomaSettings === '-'">
                {{kymw4800Model.crossGoodsMap[cell.item.CrossCode][i].ChildKomaSettings}}
              </div>
            </div>
          </ng-template>
        </wj-flex-grid-column>
      </ng-template>
    </wj-flex-grid>
  </div>

  <footer class="footer-buttons">
    <button id="btn_Set" class="btn-primary" (click)="eventBtnSet_CLICKHandler()" [tabindex]="0"
     [disabled]="kymw4800Model.isDisabledButtonSetting">設定</button>
  </footer>
</div>
